// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mortgage-connections-container {
  display: flex;
  width: 100%;
  flex-direction: column;
  font-family: "Proxima Nova", sans-serif;
}
.mortgage-connections-container .contents {
  margin-top: 60px;
  max-height: calc(100vh - 140px);
}
.mortgage-connections-container .table-filters {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 350px;
}
.mortgage-connections-container #connections-table tr > td {
  height: 80px;
}
.mortgage-connections-container #connections-table tr > td > p {
  margin: 0;
  line-height: normal;
}
.mortgage-connections-container .buyer-container {
  display: flex;
  width: -moz-fit-content;
  width: fit-content;
  align-items: center;
  padding-left: 16px;
}
.mortgage-connections-container .buyer-container .buyer-image {
  width: 32px;
  height: 32px;
  object-fit: cover;
  border-radius: 50px;
  margin-right: 16px;
}
.mortgage-connections-container .buyer-container .buyer-info {
  color: var(--secondary-color-5);
  font-weight: 700;
  font-size: 12px;
  transition: 0.3s ease-in-out;
  cursor: pointer;
}
.mortgage-connections-container .buyer-container .buyer-info:hover {
  color: var(--primary-color-1);
}
.mortgage-connections-container .add-buyer-modal {
  opacity: 0;
  visibility: hidden;
  height: 100vh;
  width: 100vw;
  transition: 0.3s ease-in-out;
  position: fixed;
  background: white;
  top: 0;
  left: 0;
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
}
.mortgage-connections-container .add-buyer-modal.visible {
  opacity: 1;
  visibility: visible;
}
.mortgage-connections-container .add-buyer-modal .form-section {
  height: 640px !important;
  width: 640px !important;
  background: #FFFFFF;
  box-shadow: 0px 4px 20px rgba(53, 99, 55, 0.2);
  border-radius: 10px;
  padding: 50px 70px;
  display: flex;
  flex-direction: column;
}
.mortgage-connections-container .add-buyer-modal .form-section .section-title {
  margin: 0;
  font-weight: 700;
  font-size: 20px;
  color: var(--secondary-color-1);
}
.mortgage-connections-container .add-buyer-modal .form-section .section-title > span {
  font-size: 14px;
  font-weight: 600;
  color: #6C767C;
}
.mortgage-connections-container .add-buyer-modal .form-section > button {
  height: 45px;
  font-size: 16px;
}
.mortgage-connections-container .add-buyer-modal .form-section > button.cancel {
  background: var(--secondary-color-4);
  color: var(--secondary-color-3);
}
.mortgage-connections-container .add-buyer-modal .form-section > button.cancel:hover {
  opacity: 0.75;
}
.mortgage-connections-container .pagination {
  display: flex;
  align-items: center;
  column-gap: 16px;
}
.mortgage-connections-container .pagination > p {
  cursor: pointer;
  font-family: "Proxima Nova", sans-serif;
  font-size: 12px;
  font-weight: 760;
  color: #949494;
}
.mortgage-connections-container .pagination > p:hover {
  opacity: 0.75;
}
.mortgage-connections-container .pagination > p.next {
  text-align: right;
}
.mortgage-connections-container .pagination > ul {
  display: flex;
  font-family: "Proxima Nova", sans-serif;
}
.mortgage-connections-container .pagination > ul > li {
  cursor: pointer;
  font-weight: 700;
  color: var(--secondary-color-3);
  font-size: 18px;
}
.mortgage-connections-container .pagination > ul > li:hover {
  opacity: 0.75;
}
.mortgage-connections-container .pagination > ul > li.active {
  color: var(--secondary-color-1);
  text-decoration: underline;
}

@media (min-width: 481px) and (max-width: 767px), (min-width: 320px) and (max-width: 480px) {
  .mortgage-connections-container #connections-table tr > td {
    height: auto;
  }
  .mortgage-connections-container .document-wrapper {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: flex-end;
    text-align: right;
  }
  .mortgage-connections-container .dashboard-filters-container .table-filters {
    display: none;
  }
  .mortgage-connections-container .dashboard-filters-container .buttons {
    width: 100%;
  }
  .mortgage-connections-container .connection-action-block-container {
    padding-right: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/routes/MortgageDashboard/modules/MortgageConnections/connections.scss","webpack://./src/assets/styles/_mixins.scss"],"names":[],"mappings":"AAEA;EACI,aAAA;EACA,WAAA;EACA,sBAAA;EACA,uCAAA;AADJ;AAEI;EACI,gBAAA;EACA,+BAAA;AAAR;AAEI;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,YAAA;AAAR;AAEI;EACI,YAAA;AAAR;AACQ;EACI,SAAA;EACA,mBAAA;AACZ;AAEI;EACI,aAAA;EACA,uBAAA;EAAA,kBAAA;EACA,mBAAA;EACA,kBAAA;AAAR;AACQ;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;AACZ;AACQ;EACI,+BAAA;EACA,gBAAA;EACA,eAAA;EACA,4BAAA;EACA,eAAA;AACZ;AAAY;EACI,6BAAA;AAEhB;AAEI;EACI,UAAA;EACA,kBAAA;EACA,aAAA;EACA,YAAA;EACA,4BAAA;EACA,eAAA;EACA,iBAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAAR;AACQ;EACI,UAAA;EACA,mBAAA;AACZ;AACQ;EACI,wBAAA;EACA,uBAAA;EACA,mBAAA;EACA,8CAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;AACZ;AAAY;EACI,SAAA;EACA,gBAAA;EACA,eAAA;EACA,+BAAA;AAEhB;AADgB;EACI,eAAA;EACA,gBAAA;EACA,cAAA;AAGpB;AAAY;EACI,YAAA;EACA,eAAA;AAEhB;AADgB;EACI,oCAAA;EACA,+BAAA;AAGpB;AAFoB;EAAU,aAAA;AAK9B;AAAI;EACI,aAAA;EACA,mBAAA;EACA,gBAAA;AAER;AADQ;EACI,eAAA;EACA,uCAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAGZ;AAFY;EAAU,aAAA;AAKtB;AAJY;EAAS,iBAAA;AAOrB;AALQ;EACI,aAAA;EACA,uCAAA;AAOZ;AANY;EACI,eAAA;EACA,gBAAA;EACA,+BAAA;EACA,eAAA;AAQhB;AAPgB;EAAU,aAAA;AAU1B;AATgB;EACI,+BAAA;EACA,0BAAA;AAWpB;;AChIY;ED8HJ;IACI,YAAA;EAMV;EAJM;IACI,aAAA;IACA,uBAAA;IACA,sBAAA;IACA,qBAAA;IACA,iBAAA;EAMV;EAHU;IACI,aAAA;EAKd;EAHU;IAAW,WAAA;EAMrB;EAJM;IACI,gBAAA;EAMV;AACF","sourcesContent":["@import 'assets/styles/_mixins.scss';\r\n\r\n.mortgage-connections-container {\r\n    display: flex;\r\n    width: 100%;\r\n    flex-direction: column;\r\n    font-family: \"Proxima Nova\", sans-serif;\r\n    .contents {\r\n        margin-top: 60px;\r\n        max-height: calc(100vh - 140px);\r\n    }\r\n    .table-filters {\r\n        display: flex;\r\n        justify-content: space-between;\r\n        align-items: center;\r\n        width: 350px;\r\n    }    \r\n    #connections-table tr > td {\r\n        height: 80px;  \r\n        > p {\r\n            margin: 0;\r\n            line-height: normal;\r\n        }\r\n    }\r\n    .buyer-container {\r\n        display: flex;\r\n        width: fit-content;\r\n        align-items: center;\r\n        padding-left: 16px;\r\n        .buyer-image {\r\n            width: 32px;\r\n            height: 32px;\r\n            object-fit: cover;\r\n            border-radius: 50px;\r\n            margin-right: 16px;\r\n        }\r\n        .buyer-info {\r\n            color: var(--secondary-color-5);\r\n            font-weight: 700;\r\n            font-size: 12px;\r\n            transition: .3s ease-in-out;\r\n            cursor: pointer;\r\n            &:hover {\r\n                color: var(--primary-color-1);\r\n            }\r\n        }\r\n    }\r\n    .add-buyer-modal {\r\n        opacity: 0;\r\n        visibility: hidden;\r\n        height: 100vh;\r\n        width: 100vw;\r\n        transition: .3s ease-in-out;\r\n        position: fixed;\r\n        background: white;\r\n        top: 0;\r\n        left: 0;\r\n        z-index: 999;\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n        &.visible {\r\n            opacity: 1;\r\n            visibility: visible;\r\n        }\r\n        .form-section {\r\n            height: 640px !important;\r\n            width: 640px !important;\r\n            background: #FFFFFF;\r\n            box-shadow: 0px 4px 20px rgba(53, 99, 55, 0.2);\r\n            border-radius: 10px;\r\n            padding: 50px 70px;\r\n            display: flex;\r\n            flex-direction: column;\r\n            .section-title {\r\n                margin: 0;\r\n                font-weight: 700;\r\n                font-size: 20px;\r\n                color: var(--secondary-color-1);\r\n                > span {\r\n                    font-size: 14px;\r\n                    font-weight: 600;\r\n                    color: #6C767C;\r\n                }\r\n            }\r\n            > button {\r\n                height: 45px;\r\n                font-size: 16px;\r\n                &.cancel {\r\n                    background: var(--secondary-color-4);\r\n                    color: var(--secondary-color-3);\r\n                    &:hover { opacity: .75; }\r\n                }\r\n            }\r\n        }\r\n    }\r\n    .pagination {\r\n        display: flex;\r\n        align-items: center;\r\n        column-gap: 16px;\r\n        > p {\r\n            cursor: pointer;\r\n            font-family: 'Proxima Nova', sans-serif;  \r\n            font-size: 12px;\r\n            font-weight: 760;\r\n            color: #949494;\r\n            &:hover { opacity: .75; }\r\n            &.next { text-align: right; }\r\n        }\r\n        > ul {\r\n            display: flex;\r\n            font-family: 'Proxima Nova', sans-serif;  \r\n            > li { \r\n                cursor: pointer;\r\n                font-weight: 700;\r\n                color: var(--secondary-color-3);\r\n                font-size: 18px;\r\n                &:hover { opacity: .75; }\r\n                &.active {\r\n                    color: var(--secondary-color-1);\r\n                    text-decoration: underline;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n@include media(mobile) {\r\n    .mortgage-connections-container {\r\n        #connections-table tr > td {\r\n            height: auto;\r\n        }\r\n        .document-wrapper {\r\n            display: flex;\r\n            justify-content: center;\r\n            flex-direction: column;\r\n            align-items: flex-end;\r\n            text-align: right;\r\n        }\r\n        .dashboard-filters-container {\r\n            .table-filters {\r\n                display: none;\r\n            }\r\n            .buttons { width: 100%; }\r\n        }\r\n        .connection-action-block-container {\r\n            padding-right: 0;\r\n        }\r\n    }\r\n}\r\n","@mixin media($keys...) {\r\n    @each $key in $keys {\r\n        @if ($key==mobile) {\r\n            @media (min-width: 481px) and (max-width: 767px),\r\n            (min-width: 320px) and (max-width: 480px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==tablet) {\r\n            @media (min-width: 768px) and (max-width: 1024px),\r\n            (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==nitty-gritt) {\r\n            @media (width: 1024px) and (max-height: 833px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==small-desktop) {\r\n            @media (max-width: 1440px) and (max-height: 833px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==desktop) {\r\n            @media (min-width: 1024px) and (max-width: 1440px) {\r\n                @content;\r\n            }\r\n        }\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
